import React from 'react';

const PBSKidsLogo = props => (
  <svg viewBox="0 0 145.5 145.5" width="60" height="60" {...props}>
    <style type="text/css">
      {
        '.pbs-kids-logo-st0{fill:#E6E6E6;}.pbs-kids-logo-st1{fill:#FFFFFF;}.pbs-kids-logo-st2{fill:#B2B2B2;}'
      }
    </style>
    <g>
      <path
        className="pbs-kids-logo-st0"
        d="M73.4,4.7c-37.6,0-68,30.4-68,68c0,37.6,30.5,68,68,68c37.6,0,68-30.4,68-68C141.4,35.2,111,4.7,73.4,4.7"
      />
      <path
        className="pbs-kids-logo-st1"
        d="M23.9,42.2c0.1-8.4,4.7-16.1,12.2-22C46.8,12.4,59.8,7.8,73.9,7.9c13.6,0.1,26.2,4.5,36.5,12
        c8.1,6.1,13,14.1,13,23c-0.1,10-6.5,18.9-16.6,25l0,0c-9.8,6-21.2,9.4-33.4,9.3C58.9,77.1,45.5,72,34.8,63.6
        C27.9,57.7,23.8,50.3,23.9,42.2"
      />
      <path
        className="pbs-kids-logo-st2"
        d="M82.7,30.5c2.5-1.4,3-5.1,3-6.2c0-5.1-3.9-8.5-11-8.5c-2.6,0-5.6,0.3-9.7,1.2v0c-0.2,0-0.4,0.2-0.4,0.5
        c0,0,0,0.1,0,0.1c1.1,6.5,1,16.7,0.2,27c0,0,0,0.1,0,0.1c0,0.2,0.2,0.4,0.4,0.5c2.5,0.6,7.5,1.1,10.3,1.1c6.7,0,11.7-3.7,11.7-9
        C87.2,33.9,85.7,31.8,82.7,30.5 M74.6,22c2.5,0,4.2,1.3,4.3,3.2c0.1,3.6-5.8,3-6.3,2.9l0-5.9C72.4,22.3,72.8,22,74.6,22 M75.2,40.1
        c-1,0-1.9-0.1-2.7-0.3l0-6c0,0,1.4-0.2,2.3-0.2c2.2,0,4.9,0.8,4.8,2.9C79.6,38.4,79,40.2,75.2,40.1"
      />
      <path
        className="pbs-kids-logo-st2"
        d="M47,19.3c-3,0.7-6.1,1.8-8.2,2.8c0,0,0,0,0,0c-0.5,0.2-0.2,0.6-0.2,0.6c2.1,4.9,5.7,21.3,6.3,26.8v0
        c0,0,0,0.1,0,0.1c0.1,0.2,0.3,0.4,0.6,0.3c0,0,6.9-2.1,6.9-2.1c0.3-0.1,0.4-0.3,0.4-0.6c0,0,0,0,0,0c0-0.1-0.1-0.3-0.1-0.6
        l-0.4-1.4L51,40.1c0,0,1.8-0.4,1.9-0.4C60.4,38,64.3,32.3,63,26.3C61.6,20.2,55.3,17.4,47,19.3 M50.6,33.5
        c-0.5,0.1-1.2,0.2-1.2,0.2L47.7,26c0,0,1.4-0.5,2-0.6c2.9-0.7,5.1,0.6,5.7,3C55.9,30.8,54.4,32.7,50.6,33.5"
      />
      <path
        className="pbs-kids-logo-st2"
        d="M104.5,27.7c0.1,0.1,0.5,0.3,0.6,0.3c0.2,0,0.3-0.1,0.3-0.1c0,0,0,0,0,0c0.4-0.4,0,0.1,3.8-4.4
        c0.1-0.1,0.1-0.2,0.1-0.3c0-0.2-0.2-0.4-0.2-0.4c0,0-3.6-3.4-9-4c-6.6-0.7-11.3,3.2-11.6,9c-0.3,4.8,3,7.5,9.6,9.7
        c4.7,1.5,3.1,4.7,0.2,4.6c-1.8-0.1-4.6-1.4-6.4-3c0,0-0.1-0.1-0.3-0.1c-0.2,0-0.3,0-0.4,0.2l-3.7,4.3c0,0-0.1,0.2-0.1,0.3
        c0,0.3,0.2,0.4,0.2,0.4c2.7,2.8,6.3,4.3,9.9,4.5c6.2,0.4,10.7-3.3,11.1-8.8c0.5-5.8-4.5-7.9-8.1-9.1c-3.1-1-4.3-2-4.2-3.3
        C96.4,26.2,99,24.3,104.5,27.7"
      />
      <path
        className="pbs-kids-logo-st1"
        d="M118.5,77.7c4,1.7,8.6-0.2,10.3-4.2c1.7-4-0.2-8.6-4.2-10.3c-4-1.7-8.6,0.2-10.3,4.2
        C112.6,71.4,114.5,76,118.5,77.7"
      />
      <path
        className="pbs-kids-logo-st1"
        d="M102.6,96.3c-0.1-3.9-3.4-7-7.4-6.9c-3.9,0.1-7,3.4-6.9,7.4c0.1,3.9,3.4,7,7.4,6.9
        C99.6,103.5,102.7,100.2,102.6,96.3"
      />
      <path
        className="pbs-kids-logo-st1"
        d="M65.9,119.1c6.9-1.7,11.2-8.7,9.4-15.6c-1.7-6.9-8.8-11.1-15.7-9.4c-6.9,1.7-11.2,8.7-9.4,15.6
        C51.9,116.6,59,120.8,65.9,119.1"
      />
      <path
        className="pbs-kids-logo-st2"
        d="M89.5,120.6c1.8-1.3,2.3-3.8,1-5.7c-1.3-1.8-3.9-2.3-5.7-1c-1.8,1.3-2.3,3.8-1,5.7c0.6,0.9,1.6,1.5,2.6,1.7
        C87.5,121.4,88.6,121.2,89.5,120.6 M86.1,118c-0.4-0.6-0.3-1.4,0.3-1.8c0.6-0.4,1.4-0.3,1.8,0.3c0.4,0.6,0.3,1.4-0.3,1.8
        c-0.3,0.2-0.6,0.3-1,0.2C86.6,118.4,86.3,118.2,86.1,118"
      />
      <path
        className="pbs-kids-logo-st2"
        d="M96,121.1c-5.5,6.7-14.3,7.4-14.4,7.5l-0.1,0l-0.1,0c-10.3,1.6-18.5-3.4-18.6-3.5c-0.7-0.5-1.7-0.2-2.2,0.5
        c-0.5,0.7-0.2,1.7,0.5,2.2c0.4,0.2,9.2,5.7,20.7,3.9c0.7-0.1,10.4-1,16.6-8.6c0.2-0.3,0.3-0.6,0.4-1c0-0.5-0.2-0.9-0.6-1.2
        C97.5,120.3,96.5,120.4,96,121.1"
      />
      <path
        className="pbs-kids-logo-st2"
        d="M59.3,92.6c-3.8,0.9-7,3.3-9,6.6c-2,3.3-2.6,7.2-1.6,10.9c1.9,7.7,9.8,12.5,17.6,10.5c3.8-0.9,7-3.3,9-6.6
        c2-3.3,2.6-7.2,1.6-10.9C74.9,95.4,67,90.6,59.3,92.6 M51.7,109.3c-0.7-2.9-0.3-5.9,1.3-8.5c1.6-2.6,4.1-4.4,7-5.2
        c6.1-1.5,12.3,2.2,13.8,8.2c0.2,0.8,0.3,1.6,0.3,2.4c0.1,2.2-0.5,4.3-1.6,6.2c-1.6,2.6-4.1,4.5-7,5.2
        C59.4,119.1,53.2,115.4,51.7,109.3"
      />
      <path
        className="pbs-kids-logo-st2"
        d="M55.6,112.8c2.6,0.3,4.9-1.5,5.2-4c0.3-2.5-1.5-4.9-4-5.2c-2.6-0.3-4.9,1.5-5.2,4
        C51.3,110.2,53.1,112.5,55.6,112.8"
      />
      <path
        className="pbs-kids-logo-st2"
        d="M86.9,96.8c0.2,4.7,4.1,8.4,8.8,8.2c4.7-0.2,8.4-4.1,8.3-8.8c-0.2-4.7-4.1-8.4-8.8-8.2
        C90.4,88.1,86.7,92.1,86.9,96.8 M89.4,96.7c-0.1-3.3,2.5-6.1,5.8-6.2c3.3-0.1,6.1,2.5,6.2,5.8c0.1,3.3-2.5,6.1-5.8,6.2
        C92.3,102.6,89.6,100,89.4,96.7"
      />
      <path
        className="pbs-kids-logo-st2"
        d="M92.3,100.5c1.7,0.2,3.3-1,3.5-2.7c0.2-1.7-1-3.3-2.7-3.5c-1.7-0.2-3.3,1-3.5,2.7
        C89.3,98.7,90.5,100.3,92.3,100.5"
      />
      <path
        className="pbs-kids-logo-st2"
        d="M110.6,97.5c-1.9-9.4-7.2-17.6-15.1-23.1h0c0,0,0,0,0,0c-0.3-0.2-0.6-0.4-0.9-0.6c-1.2-0.8-2.4-1.5-3.6-2.1
        c-9-4.8-23.7-9.5-57.5,4.2l6.2,5.8L27.5,86l9.5,6.1l-11,4.1l10.3,7.3c-3.4,1.7-5.8,5.2-5.9,9.3c-0.1,5.9,4.6,10.9,10.5,11
        c0.9,0,1.7-0.1,2.6-0.3c8,12.3,22.9,19.3,38.1,16.5c9.5-1.7,17.7-7,23.2-14.8C110.5,117.2,112.6,107.3,110.6,97.5 M40.9,120.8
        c-4.2-0.1-7.6-3.6-7.5-7.9c0.1-3.1,2-5.7,4.6-6.9c0.1,1.6,0.3,3.1,0.6,4.7c0.7,3.6,1.9,6.9,3.5,10
        C41.8,120.8,41.4,120.8,40.9,120.8 M102.1,123.5c-5,7.1-12.5,11.9-21.1,13.5c-18.2,3.4-35.9-8.7-39.5-26.8
        c-1.4-7-0.5-13.9,2.2-19.9l47.9-14.7c0.4,0.2,0.8,0.5,1.2,0.7c7.7,5.1,12.9,12.8,14.7,21.8C109.2,107,107.3,116.1,102.1,123.5"
      />
      <path
        className="pbs-kids-logo-st1"
        d="M111.2,82.3c-1.2,2-0.6,4.6,1.4,5.8c2,1.2,4.6,0.6,5.8-1.4c1.2-2,0.6-4.6-1.4-5.8
        C115,79.7,112.4,80.3,111.2,82.3"
      />
      <path
        className="pbs-kids-logo-st2"
        d="M69.4,63.7L69.4,63.7l-0.2-1.1L69,60.5l0-0.1l-0.3-6.5l0-0.1l0-2.1l0.1-1l0,0c0-0.1,0-0.1-0.1-0.1
        c0,0-0.9,0-1.8,0.1c-0.9,0-1.8,0.1-1.8,0.1c0,0-0.1,0-0.1,0.1h0l0,0l0.2,1l0.2,2.1l0,0.1l0.3,6.5l0,0.1l0.1,2.1l-0.1,1.2
        c0,0,0,0,0,0c0,0.1,0.1,0.1,0.1,0.1l0.2,0l3.3-0.2l0.2,0C69.4,63.8,69.4,63.8,69.4,63.7C69.4,63.7,69.4,63.7,69.4,63.7"
      />
      <path
        className="pbs-kids-logo-st2"
        d="M85.4,57.7c-0.2,4.2-4.1,6.6-8.1,6.4c-0.9,0-1.1-0.1-2-0.1c-0.9-0.1-2-0.1-2-0.1l-0.2,0
        c-0.1,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0h0l0.2-1.2l0.1-2.2l0-0.1l0.3-6.6l0-0.1l0-2.1l-0.1-1.1l0,0c0-0.1,0.1-0.1,0.1-0.1
        c0,0,0.8,0,1.2,0c0.5,0,2-0.1,3,0C82.1,50.6,85.6,53.3,85.4,57.7 M77.8,53.4c-0.3,0-0.5,0-0.7,0l0,0.4v0.1l-0.3,6.6v0.1l0,0.7
        c0.2,0,0.4,0.1,0.7,0.1c2.1,0.1,4.4-1.1,4.5-3.6C82,55.2,79.8,53.4,77.8,53.4"
      />
      <path
        className="pbs-kids-logo-st2"
        d="M62.9,63.9l-5.8-5.6c1.3-1.4,2.6-2.8,4.1-4c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1l-2.3-2.3
        c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c-2.2,2-4.3,4.2-6.1,6.6l-0.4-2.5l0-0.1l-0.3-2.1l0-1l0,0c0-0.1-0.1-0.1-0.1-0.1
        c0,0-0.9,0.2-1.8,0.3c-0.9,0.2-1.8,0.3-1.8,0.3c0,0-0.1,0.1-0.1,0.1v0l0.3,1l0.4,2l0,0.1l1.2,6.4l0,0.1l0.3,2.1l0,1.2l0,0
        c0,0,0,0,0,0c0,0.1,0.1,0.1,0.1,0.1v0l0.2,0l3.2-0.6l0.2,0c0.1,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0h0l-0.4-1.1l-0.3-1.2l0-0.1
        c0.5-0.8,1.1-1.6,1.6-2.3l3.8,4v0c0,0,0.1,0,0.1,0c0,0,0,0,0,0v0l3.9-0.7v0c0,0,0,0,0,0C62.9,64.1,63,64,62.9,63.9
        C63,63.9,62.9,63.9,62.9,63.9"
      />
      <path
        className="pbs-kids-logo-st2"
        d="M99.4,62.2c0.8-5.8-7.9-4.8-7.6-6.7c0.2-1.2,3.6-1.6,6.1,1.2c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0v0
        c0.4-0.4,1.7-1.9,2-2.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1h0c0,0,0,0,0,0c0,0,0,0,0,0c-2-3.4-11.1-4.9-11.9,0.7
        c-0.8,5.4,8.1,5.2,7.7,6.9c-0.4,1.6-4.9,1.2-6.7-1.7c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.4,0.3-2,1.7-2.4,2c0,0,0,0,0,0
        c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0C90.2,67.6,98.6,67.9,99.4,62.2"
      />
    </g>
  </svg>
);

export default PBSKidsLogo;
